import { render, staticRenderFns } from "./TucowsPromoSuggestions.vue?vue&type=template&id=9ef36526"
import script from "./TucowsPromoSuggestions.vue?vue&type=script&lang=js"
export * from "./TucowsPromoSuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports